import { OutlineElement } from '@phase2/outline-core';
import { html, TemplateResult, CSSResultArray } from 'lit';
import { customElement } from 'lit/decorators.js';

import componentStyles from './pc-block.css.lit';

/**
 * Block component
 * @element pc-block
 * @slot - This element has a default slot
 */
@customElement('pc-block')
export class PCBlock extends OutlineElement {
  static styles: CSSResultArray = [componentStyles];

  render(): TemplateResult {
    return html`
      <div class="block">
        <slot name="title"></slot>
        <div class="content">
          <slot name="content"></slot>
        </div>
      </div>
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'pc-block': PCBlock;
  }
}
